<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_iii"></a>City of Dragons</h1>
<p class="author"><img alt="Image" class="block" src="images/dragon.jpg"/> KELLI STANLEY</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.jpg"/><br/><span class="underline">        Minotaur Books        </span><br/>A Thomas Dunne Book<br/>New York<br/><img alt="Image" src="images/pub1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7b3c6120